import forEach from "./customForEach";

function checkNote(textArea) {
    let classesList = ["in-progress", "complete"];
    let minLength = textArea.getAttribute("minlength");
    let notes = document.querySelectorAll("[data-field-name=review]");
    let textAreaValueLength = textArea.value.length;
    if (notes.length > 0) {
        let note = notes[0];
        if (textAreaValueLength > 0 && textAreaValueLength < minLength) {
            note.classList.remove(...classesList);
            note.classList.add("in-progress");
        } else if (textAreaValueLength >= minLength) {
            note.classList.remove(...classesList);
            note.classList.add("complete");
        } else {
            note.classList.remove(...classesList);
        }

        let counters = note.querySelectorAll(".modal-reviews__note-value");
        if (counters.length > 0) {
            let counter = counters[0];
            counter.innerHTML = textAreaValueLength;
        }
    }
}

function initCheckNote() {
    forEach(
        document.querySelectorAll("textarea[name=review]"),
        function (index, textArea) {
            checkNote(textArea);
            textArea.addEventListener("keyup", function (event) {
                checkNote(textArea);
            });
        }
    );
}

export default initCheckNote;
